import "slick-carousel/slick/slick";

if(jQuery('.news-teaser-slider').length >= 1) {
    jQuery(".news-teaser-slider").on('init', function(event, slick){
        if(jQuery(".news-teaser-slider .slick-slide:not(.slick-cloned)").length <= 1){
            jQuery(".news-teaser-sec .slick-arrow").addClass("hidden");
        }
    });
    
    jQuery(document).ready(function () {
        jQuery(".news-teaser-slider").slick({
            slidesToShow: 1,
            arrows: false,
            prevArrow: jQuery(".news-teaser__prev"),
            nextArrow: jQuery(".news-teaser__next"),
            dots: true,
            speed: 500,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        arrows: true,
                    }
                },
            ]
        });
    });
}